import React, { Component } from "react"
import { Mutation } from "react-apollo"
import NEWSLETTER_SUBSCRIBE from "../../../graphql/newsletterSubscribe.graphql"
import PropTypes from "prop-types"

// import './newsletterSignup.scss'

class NewsletterSignup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: "",
      successMessage: false,
      errors: { email: false },
    }
  }

  isValidEmail = () => {
    let reg = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/
    let isValid = reg.test(this.state.email)
    if (isValid && this.state.email.length !== 0) {
      this.setState({ errors: { email: false } })
    } else {
      this.setState({
        errors: { email: "Invalid email." },
      })
    }
  }

  signup = () => {
    let { email, errors } = this.state
    this.isValidEmail()
    if (!errors.email && this.state.email.length !== 0) {
      this.props.trackEvent("newsletter subscription submited")
      this.props.newsletterSubscribe({ variables: { email } }).then((res) => {
        let { subscribeNewsletter } = res.data
        if (subscribeNewsletter) {
          if (subscribeNewsletter.payload.toLowerCase() === "success") {
            this.setState({
              successMessage: "Thank you for subscribing to our newsletter",
            })
          }
          if (subscribeNewsletter.payload.toLowerCase() === "exists") {
            this.setState({
              successMessage: "You are already subscribed to the newsletter.",
            })
          }
        }
      })
    }
  }

  onInputBlur = () => {
    this.setState(
      {
        inputBlur: true,
      },
      this.isValidEmail
    )
  }

  renderSuccessMessage = () => {
    if (!this.state.successMessage) {
      return null
    }
    return <div className="form-success">{this.state.successMessage}</div>
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    return (
      <div id="newsletter">
        <div className="newsletter-form--container">
          <div className="newsletter-form--content">
            <h1 className="newsletter-form--header">Newsletter</h1>
            <div>
              <p className="newsletter-form-subheader">{this.props.title}</p>
              <div className="input-group mb-3 newsletter-form">
                {this.state.errors.email && (
                  <p className="message--error">{this.state.errors.email}</p>
                )}
                <input
                  className={`form-control input-outline ${
                    this.state.errors.email ? "error" : ""
                  }`}
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  onChange={(e) => this.handleInputChange(e)}
                  onBlur={this.onInputBlur}
                  value={this.state.email}
                  name="email"
                  placeholder="Enter your email address"
                  style={{ width: "100%" }}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn--subscription "
                    id="button-addon2"
                    onClick={this.signup}
                  >
                    {" "}
                    Subscribe
                  </button>
                </div>
              </div>
              {this.renderSuccessMessage()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

NewsletterSignup.propTypes = {
  title: PropTypes.string.isRequired,
  newsletterSubscribe: PropTypes.func.isRequired,
}

const NewsletterSignupWithData = (props) => {
  return (
    <Mutation mutation={NEWSLETTER_SUBSCRIBE}>
      {(mutate) => <NewsletterSignup {...props} newsletterSubscribe={mutate} />}
    </Mutation>
  )
}

export default NewsletterSignupWithData
